import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { FormSchemaType } from "@/features/hmo-consultation/schema";
import { useFormContext } from "react-hook-form";

type GenderFieldProps = {
  readOnly?: boolean
};

export function GenderField(props: GenderFieldProps) {
  const form = useFormContext<FormSchemaType>()

  return (
    <FormField
      control={form.control}
      name="gender"
      render={({ field }) => {

        return (
          <FormItem>
            <FormLabel>Gender</FormLabel>
            <Select
              disabled={props.readOnly || false}
              onValueChange={field.onChange}
              defaultValue={field.value}
            >
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder="Select a gender" />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                <SelectItem value="male">Male</SelectItem>
                <SelectItem value="female">Female</SelectItem>
              </SelectContent>
            </Select>
            <FormMessage />
          </FormItem>
        )
      }}
    />
  )
}